import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css'; // Import Tailwind CSS base styles
import { PostHogProvider } from 'posthog-js/react';
import { initPerformanceMonitoring } from './utils/webVitals';

// Import security manager for production protection (only if enabled)
if (process.env.REACT_APP_ENABLE_SECURITY_PROTECTION === 'true') {
  import('./utils/securityManager');
}

// Initialize performance monitoring
initPerformanceMonitoring();

// Register service worker for caching
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('[SW] Service Worker registered successfully:', registration.scope);

        // Check for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New content is available, notify user
                console.log('[SW] New content is available and will be used when all tabs for this page are closed.');
              }
            });
          }
        });
      })
      .catch((error) => {
        console.error('[SW] Service Worker registration failed:', error);
      });
  });
}

// Find the root DOM element
const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');

// Create a root and render the App component
const root = createRoot(container);

const isLocal = !process.env.VITE_PUBLIC_POSTHOG_KEY || window.location.hostname === 'localhost';

root.render(
  <React.StrictMode>
    {isLocal ? (
      <App />
    ) : (
      <PostHogProvider
        apiKey={process.env.VITE_PUBLIC_POSTHOG_KEY}
        options={{
          api_host: process.env.VITE_PUBLIC_POSTHOG_HOST,
          capture_exceptions: true,
          debug: process.env.MODE === 'development',
          session_recording: {
            enabled: true,
            console: true, // enables console log recording
          },
        }}
      >
        <App />
      </PostHogProvider>
    )}
  </React.StrictMode>
);
